import { useCallback } from "react";

import { useTransitionRouter } from "../../../transition-router";
import { CloseConfirmationModal } from "../close-confirmation-modal";
import { useModalHistoryStepCounter } from "../history/use-modal-history-step-counter";
import { resolveModalId } from "../modal-id";
import { useRouteModalsStore } from "../route-modals.store";
import { useUserTriggeredModalsStore } from "../user-triggered-modals.store";
import { useModalSetOperations } from "./use-modal-set-operations";

export const useModalConfirmOperations = () => {
  const router = useTransitionRouter();

  const countStepsToReachModalState = useModalHistoryStepCounter();

  const routeModalFallbackPath = useRouteModalsStore((state) => state.fallbackPath);
  const peekOpenIds = useUserTriggeredModalsStore((state) => state.peekOpenIds);

  const clearRouteState = useRouteModalsStore((state) => state.clearState);
  const clearUserTriggeredState = useUserTriggeredModalsStore((state) => state.clearState);

  const { setUserTriggeredModals } = useModalSetOperations();

  const confirmAndDismissAll = useCallback(
    (args: { triggererId?: string; isRouteModal?: boolean }) => {
      const openModalIds = peekOpenIds();

      if (args.isRouteModal) {
        const stepsToGoBack = countStepsToReachModalState([]);

        clearRouteState();

        if (stepsToGoBack) return window.history.go(-stepsToGoBack - 1);
        return router.push(routeModalFallbackPath);
      }
      if (args.triggererId) {
        const expectedModalIds = openModalIds.filter((modalId) => {
          return ![args.triggererId, resolveModalId(CloseConfirmationModal)].includes(modalId);
        });
        clearUserTriggeredState(args.triggererId);
        setUserTriggeredModals(expectedModalIds);
      }
    },
    [
      router,
      routeModalFallbackPath,
      setUserTriggeredModals,
      countStepsToReachModalState,
      peekOpenIds,
      clearRouteState,
      clearUserTriggeredState,
    ],
  );

  return { confirmAndDismissAll };
};
